<div class="bsp-content-container d-flex flex-grow-1">
  <sk-subscription-grid class="d-flex flex-grow-1 flex-column"
    [orderId]="orderId">
  </sk-subscription-grid>
</div>
